<template>
  <div v-loading.fullscreen="loading">
    <div class="header-scroll">
      <div class="header">
        <el-button type="info" @click="$router.push({ name: 'ManagerBoards' })">
          Orqaga
        </el-button>

        <el-select
          v-model="board_id"
          placeholder="Mavsum"
          clearable
          filterable
          class="header-control"
          :loading="boardsLoading"
          @change="onFilterChange"
        >
          <el-option
            v-for="board in boards"
            :key="board.id"
            :value="board.id"
            :label="boardLabel(board)"
          />
        </el-select>

        <el-select
          v-model="manager_id"
          placeholder="Boshqaruvchi"
          clearable
          filterable
          class="header-control"
          :loading="managersLoading"
          @change="onFilterChange"
        >
          <el-option
            v-for="manager in managers"
            :key="manager.id"
            :value="manager.id"
            :label="manager.fullname"
          />
        </el-select>

        <el-select
          v-model="action"
          placeholder="Amal turi"
          clearable
          class="header-control"
          @change="onFilterChange"
        >
          <el-option value="ASSIGN_DEPUTY_OKRUG" label="Biriktirish" />
          <el-option value="UNASSIGN_DEPUTY_OKRUG" label="Biriktirish bekor qilindi" />
        </el-select>
      </div>
    </div>

    <el-table :data="logs" border height="calc(100vh - 270px)">
      <el-table-column type="index" :index="indexMethod" width="60" />
      <el-table-column prop="manager_fullname" label="Boshqaruvchi" min-width="200" />
      <el-table-column label="Amal" min-width="180">
        <template #default="scope">
          <el-tag :type="scope.row.action === 'ASSIGN_DEPUTY_OKRUG' ? 'success' : 'danger'">
            {{ actionLabel(scope.row.action) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="board_id" label="Mavsum ID" min-width="120" />
      <el-table-column prop="okrug_id" label="Okrug ID" min-width="100" />
      <el-table-column prop="deputy_id" label="Deputat ID" min-width="220" />
      <el-table-column label="Vaqt" min-width="170">
        <template #default="scope">
          {{
            scope.row.created_at
              ? $moment(scope.row.created_at).format("DD-MM-YYYY / HH:mm")
              : "-"
          }}
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <div>Loglar soni: {{ totalCount }}</div>
      <el-pagination
        background
        layout="sizes, prev, pager, next"
        :total="totalCount"
        v-model:page-size="limit"
        v-model:current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { ElNotification } from "element-plus";

export default {
  name: "ManagerLogs",
  data() {
    return {
      loading: false,
      logs: [],
      totalCount: 0,
      limit: 20,
      currentPage: 1,
      action: "",
      board_id: "",
      manager_id: "",
      boards: [],
      managers: [],
      boardsLoading: false,
      managersLoading: false,
    };
  },
  methods: {
    indexMethod(index) {
      return this.limit * (this.currentPage - 1) + index + 1;
    },
    boardLabel(board) {
      const parts = [board.title, board.year].filter(Boolean).join(" ");
      return board.season ? `${parts} (${board.season}-mavsum)` : parts;
    },
    actionLabel(action) {
      const map = {
        ASSIGN_DEPUTY_OKRUG: "Biriktirish",
        UNASSIGN_DEPUTY_OKRUG: "Biriktirish bekor qilindi",
      };
      return map[action] || action;
    },
    getLogs() {
      this.loading = true;
      this.$http
        .get("api/v1/deputyv2/deputy-manager/logs", {
          params: {
            action: this.action || null,
            board_id: this.board_id || null,
            manager_id: this.manager_id || null,
            limit: this.limit,
            offset: this.limit * (this.currentPage - 1),
          },
        })
        .then(({ data }) => {
          this.logs = data.logs || [];
          this.totalCount = data.count || 0;
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response?.data?.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getBoards() {
      this.boardsLoading = true;
      this.$http
        .get("api/v1/deputyv2/deputy-manager/boards", { params: { limit: 1000 } })
        .then(({ data }) => {
          this.boards = data.boards || [];
        })
        .catch(() => {})
        .finally(() => {
          this.boardsLoading = false;
        });
    },
    getManagers() {
      this.managersLoading = true;
      this.$http
        .get("/api/v1/managers", {
          params: { role: "deputy_manager", limit: 1000 },
        })
        .then(({ data }) => {
          this.managers = data.users || [];
        })
        .catch(() => {})
        .finally(() => {
          this.managersLoading = false;
        });
    },
    onFilterChange() {
      this.currentPage = 1;
      this.getLogs();
    },
    handleCurrentChange() {
      this.getLogs();
    },
    handleSizeChange() {
      this.currentPage = 1;
      this.getLogs();
    },
  },
  mounted() {
    this.getLogs();
    this.getBoards();
    this.getManagers();
  },
};
</script>

<style scoped>
.header-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: 10px;
}

.header {
  display: flex;
  gap: 10px;
  align-items: center;
}

.header-control {
  width: 200px;
  flex-shrink: 0;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
